import { sendGet } from 'helpers/axios'

export const apiGetListUserInfoActive = (params) => sendGet('/api/info-user-active', params)
